<template>
  <VcConfirmModal :show-dialog="show"
                  :title="$t('settings.caller_id.settings_card.title')"
                  :content-text="$t('settings.caller_id.settings_card.dialog_description')"
                  :use-offset="false"
                  :wrap-title="true"
                  size="sm"
                  @onCloseButtonClicked="$emit('cancel')">
    <template #footer>
      <VcModalFooter :buttons="buttons"
                     @onOkClicked="$emit('goToSettings')"
                     @onCancelClicked="$emit('cancel')"/>
    </template>
  </VcConfirmModal>
</template>

<script>
export default {
  name: 'CallerIdSettings',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    buttons() {
      return [
        {label: this.$t('common.dialog.cancel'), event: 'onCancelClicked', color: 'white'},
        {label: this.$t('settings.caller_id.settings_card.dialog_button'), event: 'onOkClicked', color: 'secondary'}
      ];
    }
  }
}
</script>
